var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 30V27H10.125L9.525 26.475C8.225 25.325 7.3125 24.0125 6.7875 22.5375C6.2625 21.0625 6 19.575 6 18.075C6 15.3 6.83125 12.8313 8.49375 10.6688C10.1562 8.50625 12.325 7.075 15 6.375V9.525C13.2 10.175 11.75 11.2812 10.65 12.8438C9.55 14.4062 9 16.15 9 18.075C9 19.2 9.2125 20.2938 9.6375 21.3563C10.0625 22.4188 10.725 23.4 11.625 24.3L12 24.675V21H15V30H6ZM21 29.625V26.475C22.8 25.825 24.25 24.7188 25.35 23.1562C26.45 21.5938 27 19.85 27 17.925C27 16.8 26.7875 15.7063 26.3625 14.6438C25.9375 13.5813 25.275 12.6 24.375 11.7L24 11.325V15H21V6H30V9H25.875L26.475 9.525C27.7 10.75 28.5938 12.0813 29.1562 13.5188C29.7188 14.9563 30 16.425 30 17.925C30 20.7 29.1688 23.1688 27.5063 25.3313C25.8438 27.4938 23.675 28.925 21 29.625Z",
    fill: "#1C738E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncActive);
export default __webpack_public_path__ + "static/media/Sync_active.e23e381d5e7f049a14a85c93e7154ac6.svg";
export { ForwardRef as ReactComponent };